import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";
import WithConsumer from '../context/WithConsumer';


export default class ModProjectGallery extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className={'l-block c-project-gallery'}>
	        	<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        	<div className="l-grid">
		        	
		        		{block.projects.map((project,i) =>
			        		{
				        		return (
					        		<div className="l-grid__col l-grid__col--m-6-12">
					        			<div className="c-project-gallery__block">
					        				<div className="c-image" style={{paddingTop: ((project.img_height / project.img_width) * 100) + '%'}}>
								        		<FadeIn className="c-project-gallery__block__image" duration={250}>
													{onload => (
														<img
															alt={project.img_alt} 
															src={project.img_src} 
															srcSet={project.img_srcset} 
															onLoad={onload}
														/>
													)}
												</FadeIn>
											</div>
											<h3 className="c-project-gallery__block__heading">{ project.heading }</h3>
											<h5 className="c-project-gallery__block__subheading">{ project.subheading }</h5>
					        			</div>
					        		</div>
				        		)		
			        		}
			        	)}
		        	
			        </div>
				</ScrollAnimation>
			</div>
		)
	};

};
